<template>
    <div style="height: 100%;overflow: auto;">
      <div ref="container">
        <van-sticky>
          <div style="background-color: white;">
          <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
          <el-form :inline="true" class="demo-form-inline" size="mini" v-if="indibas.length==1" style="margin-top: 5px;background-color: #fff;">
            <el-form-item label="门店">
                <el-select v-model="storeid" placeholder="门店选择" @change="storeChange" style="width: 150px;">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="active" @change="activeChange">
                <el-radio-button label="home">本月</el-radio-button>
                <el-radio-button label="home1">上月</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        </van-sticky>
      </div>
      <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;margin-bottom: 45px" :key="i" v-for="(item,i) in indibas" v-if="indibas.length==1">
        <div style="text-align: center;font-size: 14px;line-height: 30px">
          {{item.storename}}
        </div>
        <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
        <van-row style="text-align: left;line-height: 40px;font-size: 12px">
          <van-col span="24">INDIBA当月到店次数</van-col>
        </van-row>
        <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
        <div>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font">没到店人数</van-col>
            <van-col span="8" class="font">到店1次人数</van-col>
            <van-col span="8" class="font">到店2次人数</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor" >{{item.count1}}</van-col>
            <van-col span="8" class="fontcolor" >{{item.count2 }}</van-col>
            <van-col span="8" class="fontcolor" >{{item.count3}}</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font" >到店3次以上</van-col>
            <van-col span="8" class="font">总到店次数</van-col>
            <van-col span="8" class="font"></van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor">{{item.count4}}</van-col>
            <van-col span="8" class="fontcolor">{{item.totalcount}}</van-col>
            <van-col span="8" class="fontcolor"></van-col>
          </van-row>
          <!--<div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
          <van-row style="text-align: left;line-height: 40px;font-size: 12px">
            <van-col span="24">INDIBA消耗情况</van-col>
          </van-row>
          <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font">没消耗人数</van-col>
            <van-col span="8" class="font">消耗1个人数</van-col>
            <van-col span="8" class="font">消耗2个人数</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor">{{item.number1}}</van-col>
            <van-col span="8" class="fontcolor">{{item.number2}}</van-col>
            <van-col span="8" class="fontcolor">{{item.number3}}</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font">消耗3个以上</van-col>
            <van-col span="8" class="font">总消耗次数</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor">{{item.number4}}</van-col>
            <van-col span="8" class="fontcolor">{{item.totalnumber}}</van-col>
          </van-row>-->
        </div>
        <el-divider>没到店人数</el-divider>
        <el-table  :data="item.indibaXfVosnumber1" style="width: 100%;" ref="table" highlight-current-row>
          <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
          <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
        </el-table>
        <el-divider>到店1次人数</el-divider>
        <el-table  :data="item.indibaXfVosnumber2"  style="width: 100%;" highlight-current-row>
          <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
          <el-table-column prop="membername" label="会员姓名" align="center"></el-table-column>
        </el-table>
        <el-divider>到店2次人数</el-divider>
        <el-table  :data="item.indibaXfVosnumber3" style="width: 100%;" highlight-current-row>
          <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
          <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
        </el-table>
        <el-divider>到店3次以上</el-divider>
        <el-table  :data="item.indibaXfVosnumber4"  style="width: 100%;"  highlight-current-row>
          <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
          <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
        </el-table>
      </div>    
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        brands:[],
        show:false,
        cardInfoVos:[],
        indibas:[],
        height:window.innerHeight-120,
        fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
        todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
        active: 'home',
        storeid:localStorage.getItem("storeid"),
      };
    },
    created() {
      this.storeid=this.$route.query.storeid;
      //localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJBTU4wMDAwNDI3MSIsInN1YiI6IjE1MjAxOTgzNzYzIiwiaWF0IjoxNjE3NzcwNDM2LCJleHAiOjE2MTc4NTY4MzZ9.ILMIneBzlR1afn5jxIhyeEIQ0gdtncq3gNXqZrbijvc");
      //localStorage.setItem("storeid","17cc68147ccf470e884f4133312337da");
      this.getStoreInfoByStructsOpen();
      this.getIndibaXfVo();
    },
  
    methods:{
      storeChange(val){
        localStorage.setItem("storeid",val);
        this.storeid=val;
        this.getIndibaXfVo();
      },
      getStoreInfoByStructsOpen(){
        let parentstoreid=localStorage.getItem("parentstoreid");
        let staffid=localStorage.getItem("staffid");
        this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
          if(res.sucess){
              this.brands=res.object;
          }
          else{
              this.$message({
                message: res.message,
                type: 'error'
              });
          }
        });
      },
      clickData(val,type){
        if(type==1){
          this.cardInfoVos=val.indibaXfVosnumber1;
        }
        else if(type==2){
          this.cardInfoVos=val.indibaXfVosnumber2;
        }
        else if(type==3){
          this.cardInfoVos=val.indibaXfVosnumber3;
        }
        else if(type==4){
          this.cardInfoVos=val.indibaXfVosnumber4;
        }
        this.show=true;
      },
      activeChange(name){
        console.log(name);
        if(name=="home"){
          this.fromdate=this.$moment().startOf('month').format('YYYY-MM-DD');
          this.todate=this.$moment().endOf('month').format('YYYY-MM-DD');
        }
        else if(name=="home1"){
          let dates=this.$lastMonth();
          this.fromdate=dates[0];
          this.todate=dates[1];
        }
        this.getIndibaXfVo();
      },
      getIndibaXfVo(){
        let toast=this.$toast.loading({
          mask: true,
          message: '加载中...',
          duration:0
        });
        this.$post("cardmobilereoprt/getIndibaXfVo",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate}).then((res)=>{
          toast.clear();
          if(res.sucess){
              if(res.object!=null && res.object.length>1){
                  this.indibas=[];
              }
              else{
                  this.indibas=res.object;
              }
          }
          else{
            this.$dialog.alert({
              title:"提示",
              message:res.message
            });
          }
        });
      }
    }
  };
  </script>
  <style>
  .font{
    font-size: 14px;
  }
  .fontcolor{
    font-size: 14px;
    color: #1989fa;
  }
  body,html {margin:0; height:100%;}
  </style>


// WEBPACK FOOTER //
// src/page/beauty/indibaxfinfodetal.vue